module.exports = __webpack_public_path__ + "images/emoji/u7a7a.103bffe9fae084742547.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u7a7a.png
// module id = +v1q
// module chunks = 24